import { injectIntl } from "react-intl";
import { Button, Drawer } from "antd";
import { AppleApp, ApplePlus } from "../icons";
import { getMessageString } from "../../tools";

const AppleInstallationDrawerBase = ({ intl, isVisible, onClose }) => (
  <Drawer
    className="iOsInstallationDrawer"
    title={getMessageString(intl, "ld.installazione.header")}
    visible={isVisible}
    placement="top"
    onClose={onClose}
  >
    {getMessageString(intl, "ld.installazione.istruzioni1")}
    <Button icon={<AppleApp aria-label="toggle menu"/>} />
    {getMessageString(intl, "ld.installazione.istruzioni2")}
    <strong>{getMessageString(intl, "ld.installazione.istruzioni3")}</strong>
    <Button icon={<ApplePlus aria-label="toggle menu" />} />
    {getMessageString(intl, "ld.installazione.istruzioni4")}
  </Drawer>
);
export const AppleInstallationDrawer = injectIntl(AppleInstallationDrawerBase);
